// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"1b9e1d5b","78":"f6512f3f","227":"7a24093d","463":"1ff4552f","488":"29b71886","695":"eb52323a","735":"5353191f"}[chunkId] + ".chunk.js";
};